import { Box, Button, Checkbox, Grid, Paper, Typography } from '@mui/material'
import React, { useEffect, useState, useRef } from 'react'
import WORKslogans from '../../WORKslogans'
import CustomTextField from '../../CustomTextField'
import CustomDatePicker from '../../CustomDatePicker'
import CustomDropDown from '../../CustomDropDown'
import { countryCodes, genderList, qualifications, professions } from '../../../utils/constants'
import { button2Style, buttonStyle, errorTextStyle } from '../../../utils/commonCSS'
import { headingBlue } from '../../../assets/colors'
import { CloudUpload, Upload } from '@mui/icons-material'
import dayjs from 'dayjs'
import countryList from 'react-select-country-list'
import { useLocation } from 'react-router-dom'
import HttpService from '../../../backend/requestApis'
import { fetchInviteDetails, validateRegistrationLink, register } from '../../../backend/backendApis'
import { sendOtp, verifyOTP } from '../../../utils/commonFunctions'
import Loader from '../../Loader'

const RegistrationForm = () => {
    const [tab, setTab] = useState(0)
    const [name, setName] = useState('')
    const [gender, setGender] = useState('Male')
    const [DOB, setDOB] = useState()
    const [telCode, setTelCode] = useState('+91')
    const [contactNumber, setContactNumber] = useState('')
    const [email, setEmail] = useState('')
    const [adhaar, setAdhaar] = useState('')
    const [fatherName, setFatherName] = useState('')
    const [fatherContact, setFatherContact] = useState('')
    const [address, setAddress] = useState('')
    const [country, setCountry] = useState('India')
    const [state, setState] = useState('Select State')
    const [district, setDistrict] = useState('Select District')
    const [qualification, setQualification] = useState('Qualification')
    const [customQualification, setCustomQualification] = useState('')
    const [profession, setProfession] = useState('Profession')
    const [customProfession, setCustomProfession] = useState('')
    const [offAdd, setOffAdd] = useState('')
    const [offTelCode, setOffTelCode] = useState('+91')
    const [offContactNumber, setOffContactNumber] = useState('')
    const [about, setAbout] = useState('')
    const [hobbies, setHobbies] = useState('')
    const [extraCurricular, setExtraCurricular] = useState('')
    const [reasonToJoin, setReasonToJoin] = useState('')

    const [photo, setPhoto] = useState(null)
    const [signature, setSignature] = useState(null)
    const [aadharFile, setAadharFile] = useState(null)

    const [photoError, setPhotoError] = useState('')
    const [signatureError, setSignatureError] = useState('')
    const [aadharFileError, setAadharFileError] = useState('')

    const photoRef = useRef(null)
    const signatureRef = useRef(null)
    const aadharRef = useRef(null)

    const [nameError, setNameError] = useState('')
    const [dobError, setDobError] = useState('')
    const [contactNumberError, setContactNumberError] = useState('')
    const [emailError, setEmailError] = useState('')
    const [adhaarError, setAdhaarError] = useState('')

    const [fatherNameError, setFatherNameError] = useState('')
    const [fatherContactError, setFatherContactError] = useState('')
    const [addressError, setAddressError] = useState('')
    const [stateError, setStateError] = useState('')
    const [districtError, setDistrictError] = useState('')

    const [qualificationError, setQualificationError] = useState('')
    const [professionError, setProfessionError] = useState('')

    const [apiError, setApiError] = useState('')

    const [countryListData, setCountryList] = useState([])
    const [stateListData, setStateListData] = useState([])
    const [districtListData, setDistrictListData] = useState([])

    const [isLoading, setIsLoading] = useState(false)
    const [isLinkValidated, setIsLinkValidated] = useState(false)
    const [enteredOTP, setEnteredOTP] = useState('')
    const [confirmationResult, setConfirmationResult] = useState(null)
    const [authToken, setAuthToken] = useState(null)
    const [isAgreed, setIsAgreed] = useState(false)
    const [isRegistered, setIsRegistered] = useState(false)
    const location = useLocation()

    const updateName = (value) => {
        setName(() => value)
    }

    const updateGender = (value) => {
        setGender(() => value)
    }

    const updateDOB = (value) => {
        setDOB(() => value)
    }

    const updateTelCode = (value) => {
        setTelCode(() => value)
    }

    const updateContactNumber = (value) => {
        setContactNumber(() => value)
    }

    const updateEmail = (value) => {
        setEmail(() => value)
    }

    const updateAdhaar = (value) => {
        setAdhaar(() => value)
    }

    const updateFatherName = (value) => {
        setFatherName(() => value)
    }

    const updateFatherCN = (value) => {
        setFatherContact(() => value)
    }

    const updateAddress = (value) => {
        if( value.length < 200){
            setAddress(() => value)
        }
    }

    const updateCountry = (value) => {
        // setCountry(() => value)
        // setState(() => 'Select State')
        // setDistrict(() => 'Select District')
    }

    // fetchStates and fetchDistricts logic has been deprecated
    // State and District are now pre-populated as read-only fields

    const updateQualification = (value) => {
        setQualification(() => value)
    }

    const updateCustomQualification = (value) => {
        setCustomQualification(() => value)
    }

    const updateProfession = (value) => {
        setProfession(() => value)
    }

    const updateCustomProfession = (value) => {
        setCustomProfession(() => value)
    }

    const updateOffAdd = (value) => {
        if( value.length < 200){
            setOffAdd(() => value)
        }
    }

    const updateOffTelCode = (value) => {
        setOffTelCode(() => value)
    }

    const updateOffCN = (value) => {
        setOffContactNumber(() => value)
    }

    const updateAbout = (value) => {
        if( value.length < 200){
            setAbout(() => value)
        }
    }

    const updateHobbies = (value) => {
        if( value.length < 150){
            setHobbies(() => value)
        }
    }

    const updateExtraCurricular = (value) => {
        if( value.length < 200){
            setExtraCurricular(() => value)
        }
    }

    const updateReasonToJoin = (value) => {
        if( value.length < 150){
            setReasonToJoin(() => value)
        }
    }

    const handleFileUpload = (e, setFile, setError, maxSizeInKB = 200) => {
        const file = e.target.files[0];
        if (!file) return;

        if (file.type !== 'image/jpeg' && file.type !== 'image/png') {
            setError('Only JPEG and PNG files are allowed.');
            setFile(null);
            return;
        }

        if (file.size > maxSizeInKB * 1024) {
            setError(`File size must be less than ${maxSizeInKB} KB.`);
            setFile(null);
            return;
        }

        setError('');
        setFile(file);
    }

    const updateOTP = (value) => {
        setEnteredOTP(() => value)
    }

    const handleVerifyOTP = async () => {
        setIsLoading(true)
        setApiError('')
        try{
            let result = await verifyOTP(confirmationResult, enteredOTP)
            if( result){
                setAuthToken(result)
                setApiError('')
                setTab(1)
            }
        } catch(err){
            console.log('Error in verifying OTP: ', err)
            if (err?.msg && err?.msg === "auth/invalid-verification-code") {
                setApiError("Wrong OTP");
            } else if (err?.msg && err?.msg === "auth/code-expired") {
                setApiError("OTP expired.");
            } else {
                setApiError("Error in verifying OTP. Please refresh and try again.");
            }
        } finally {
            setIsLoading(false)
        }
    }

    const getCountryList = async () => {
        let countryListArray = await countryList().getData()
        countryListArray = await countryListArray.map((ele) => {
            return {'name': ele.label}
        })
        setCountryList(() => [...countryListArray])
    }

    useEffect( () => {
        getCountryList()
    }, [])

    useEffect(() => {
        if (tab === 1) {
            const token = location.search.replace('?', '');
            if (token) {
                const fetchDetails = async () => {
                    setIsLoading(true);
                    setApiError('');
                    try {
                        let options = {
                            url: fetchInviteDetails,
                            method: 'GET',
                            params: { token },
                            headers:{
                                Authorization: `Bearer ${authToken}`
                            }
                        };
                        let response = await HttpService(options);
                        if (response?.data?.status === 1 || response?.data?.data) {
                            let resData = response?.data?.data || response?.data;
                            setName(resData.name || '');
                            setContactNumber(resData.contactNumber || '');
                            setDistrict(resData.district || '');
                            setState(resData.state || '');
                        } else {
                            setApiError(response?.data?.message || 'Failed to fetch invite details');
                        }
                    } catch (error) {
                        console.error('Error fetching invite details:', error);
                        setApiError(error?.response?.data?.message || error?.message || 'Failed to fetch invite details');
                    } finally {
                        setIsLoading(false);
                    }
                };
                fetchDetails();
            }
        }
    }, [tab, location.search]);

    const handleValidate = async () => {
        setApiError('');
        setIsLoading(true);
        const token = location.search.replace('?', '');
        try {
            let options = {
                url: validateRegistrationLink,
                method: 'POST',
                payload: { token, contactNumber }
            };
            let response = await HttpService(options);
            if (response?.status === 200) {
                setIsLinkValidated(true);
            } else {
                setApiError(response?.data?.message || 'Validation failed');
            }
        } catch (error) {
            console.error('Error validating link:', error);
            setApiError(error?.response?.data?.message|| error?.response?.data?.description || error?.message || 'Failed to validate link');
        } finally {
            setIsLoading(false);
        }
    };

    const handleRegister = async () => {
        setIsLoading(true);
        setApiError('');
        const token = location.search.replace('?', '');
        
        const formData = new FormData();
        formData.append('name', name);
        formData.append('gender', gender);
        formData.append('dob', DOB ? dayjs(DOB).format('YYYY-MM-DD') : '');
        formData.append('contactNumber', contactNumber);
        formData.append('email', email);
        formData.append('adhaarNumber', adhaar);
        formData.append('fathersName', fatherName);
        formData.append('fathersOccupation', fatherContact);
        formData.append('address', address);
        formData.append('state', state);
        formData.append('district', district);
        formData.append('qualification', qualification === 'Other' ? customQualification : qualification);
        formData.append('profession', profession === 'Other' ? customProfession : profession);
        formData.append('officeAddress', offAdd);
        formData.append('officeContact', offContactNumber);
        formData.append('goal', about);
        formData.append('hobbies', hobbies);
        formData.append('extraCurricularActivities', extraCurricular);
        formData.append('reasonForJoining', reasonToJoin);
        formData.append('token', token);
        formData.append('aggrement', isAgreed);

        if (photo) formData.append('photo', photo);
        if (signature) formData.append('signature', signature);
        if (aadharFile) formData.append('aadharFile', aadharFile);

        try {
            let options = {
                url: register,
                method: 'POST',
                formData: formData,
                headers: {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        Authorization: `Bearer ${authToken}`
                    }
                }
            };
            let response = await HttpService(options);
            if (response?.status === 200 || response?.data?.status === 1) {
                setIsRegistered(true);
                setApiError('');
            } else {
                setApiError(response?.data?.message || 'Registration failed.')
            }
        } catch (error) {
            console.error('Error in registration: ', error);
            if(error?.response?.status === 409 || error?.status === 409){
                setApiError(error?.response?.data?.message || error?.response?.data?.description)
            } else {
                if (error?.response?.status === 403 || error?.status === 403) {
                    setIsLinkValidated(0)
                    setTab(0);
                } else {
                    setApiError(error?.response?.data?.message || error?.message || 'Failed to submit the form.');
                }
            }
        } finally {
            setIsLoading(false);
        }
    }

    const validateTab1 = () => {
        let isValid = true;
        if (!name) {
            setNameError('Name is required');
            isValid = false;
        } else {
            setNameError('');
        }

        if (!DOB) {
            setDobError('DOB is required');
            isValid = false;
        } else {
            setDobError('');
        }

        if (!contactNumber) {
            setContactNumberError('Contact Number is required');
            isValid = false;
        } else {
            setContactNumberError('');
        }

        if (!email) {
            setEmailError('Email is required');
            isValid = false;
        } else {
            setEmailError('');
        }

        if (!adhaar) {
            setAdhaarError('Adhaar Number is required');
            isValid = false;
        } else {
            setAdhaarError('');
        }

        if (isValid) {
            setTab(() => tab + 1);
        }
    }

    const validateTab2 = () => {
        let isValid = true;
        
        if (!fatherName) {
            setFatherNameError("Father's Name is required");
            isValid = false;
        } else {
            setFatherNameError('');
        }

        if (!fatherContact) {
            setFatherContactError("Father's Occupation is required");
            isValid = false;
        } else {
            setFatherContactError('');
        }

        if (!address) {
            setAddressError('Address is required');
            isValid = false;
        } else {
            setAddressError('');
        }

        if (!state || state === 'Select State') {
            setStateError('State is required');
            isValid = false;
        } else {
            setStateError('');
        }

        if (!district || district === 'Select District') {
            setDistrictError('District is required');
            isValid = false;
        } else {
            setDistrictError('');
        }

        if (isValid) {
            setTab(() => tab + 1);
        }
    }

    const validateTab3 = () => {
        let isValid = true;
        
        if (!qualification || qualification === 'Qualification') {
            setQualificationError('Qualification is required');
            isValid = false;
        } else if (qualification === 'Other' && !customQualification) {
            setQualificationError('Please specify your qualification');
            isValid = false;
        } else {
            setQualificationError('');
        }

        if (!profession || profession === 'Profession') {
            setProfessionError('Profession is required');
            isValid = false;
        } else if (profession === 'Other' && !customProfession) {
            setProfessionError('Please specify your profession');
            isValid = false;
        } else {
            setProfessionError('');
        }

        if (isValid) {
            console.log("tab : ", tab)
            setTab(() => tab + 1);
        }
    }

    const validateTab5 = () => {
        let isValid = true;

        if (!photo) {
            setPhotoError('Photograph is required');
            isValid = false;
        }
        if (!signature) {
            setSignatureError('Signature is required');
            isValid = false;
        }
        if (!aadharFile) {
            setAadharFileError('Aadhar Card is required');
            isValid = false;
        }

        if (isValid) {
            setTab(() => tab + 1);
        }
    }

  return (
    <>
        <Box className = 'formContainer'>
            <Box className = 'formOuterBox'>
                <Box className='formImageContainer'>
                    <img src={require("../../../assets/images/WORK_logo.png")}
                        alt = "LOGO" style={{width: '40%'}}
                    >
                    </img>
                </Box>
                {isLoading && <Loader />}
                <div id="recaptcha-container"></div>
                <Box>
                    <WORKslogans/>
                </Box>
                <Paper style={{width: '100%', marginTop: '0.75rem', padding: '0.75rem 0.5rem 0.5rem 0.5rem', border: '1px solid #D3D3D3'}}>
                    {tab === 0 && !confirmationResult &&
                        <Box style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '2rem 1rem' }}>
                            <Typography style={{ color: headingBlue, fontSize: '1.2rem', marginBottom: '0.5rem', textAlign: 'center' }}>
                                Enter your Contact Number
                            </Typography>
                            <Box style={{ display: 'flex', flexDirection: 'row', width: '15rem', justifyContent: 'center', marginBottom: '1.5rem' }}>
                                <CustomTextField 
                                    placeHolder="Contact Number" 
                                    value={contactNumber} 
                                    setFunc={updateContactNumber} 
                                    disabled={isLinkValidated}
                                />
                            </Box>
                            <Box style={{ display: 'flex', flexDirection: 'row', gap: '1rem' }}>
                                <Button 
                                    style={{...buttonStyle, opacity: isLinkValidated ? 0.5 : 1}} 
                                    onClick={handleValidate}
                                    disabled={isLinkValidated || !contactNumber}
                                >
                                    Validate
                                </Button>
                                <Button 
                                    style={{...buttonStyle, opacity: !isLinkValidated ? 0.5 : 1}} 
                                    disabled={!isLinkValidated}
                                    onClick={async () => {
                                        try {
                                            setApiError('');
                                            setIsLoading(true);
                                            const result = await sendOtp(contactNumber, '+91');
                                            setConfirmationResult(result);
                                        } catch (error) {
                                            let errMsg = error?.msg || error?.err?.message || error?.err || 'Failed to send OTP';
                                            setApiError(`${errMsg} Please Refresh and try again.`);
                                        } finally {
                                            setIsLoading(false);
                                        }
                                    }}
                                >
                                        Send OTP
                                </Button>
                            </Box>
                        </Box>
                    }
                    {tab === 0 && confirmationResult &&
                        <Box style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '2rem 1rem' }}>
                            <Typography style={{ color: headingBlue, fontSize: '1.2rem', marginBottom: '0.5rem', textAlign: 'center' }}>
                                Enter the OTP sent to {contactNumber}
                            </Typography>
                            <Box style={{ display: 'flex', flexDirection: 'row', width: '15rem', justifyContent: 'center', marginBottom: '1.5rem' }}>
                                <CustomTextField 
                                    placeHolder="Enter OTP" 
                                    value={enteredOTP} 
                                    setFunc={updateOTP} 
                                />
                            </Box>
                            <Button 
                                style={{...buttonStyle}} 
                                onClick={handleVerifyOTP}
                                disabled={!enteredOTP}
                            >
                                Verify OTP
                            </Button>
                        </Box>
                    }
                    {tab === 1 &&
                        <>
                        <Typography style={{color: headingBlue, fontSize: '1.1rem'}}><strong>Personal Details</strong></Typography>
                        <Grid container spacing={1} style={{padding: '0.75rem 0rem 0.5rem 0rem'}}>
                            <Grid item xs={12} sm={8}>
                                <CustomTextField
                                    regular={true}
                                    placeHolder= 'Name *'
                                    value={name}
                                    setFunc={() => {}}
                                    disabled={true}
                                ></CustomTextField>
                                <Typography style={errorTextStyle}>{nameError}</Typography>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <CustomDropDown list={genderList} placeHolder= 'Gender *'
                                    value={gender}
                                    setFunc={updateGender}
                                ></CustomDropDown>
                            </Grid>
                            <Grid item xs={12} sm={5}>
                                <CustomDatePicker
                                    selectedDate={DOB}
                                    setSelectedDate={updateDOB}
                                    minDateValue={dayjs(new Date('1950-01-01'))}
                                    placeHolder='DOB *'
                                ></CustomDatePicker>
                                <Typography style={errorTextStyle}>{dobError}</Typography>
                            </Grid>
                            <Grid item xs={4} sm={2} style={{paddingTop: '0.5rem'}}>
                                <CustomDropDown list={countryCodes}
                                    value={telCode}
                                    setFunc={updateTelCode}
                                ></CustomDropDown>
                            </Grid>
                            <Grid item xs={8} sm={5} style={{padding: '0.5rem 0rem 0rem 0.2rem'}}>
                                <CustomTextField 
                                    regular={true} 
                                    placeHolder='Contact Number *'
                                    value={contactNumber}
                                    setFunc={() => {}}
                                    disabled={true}
                                ></CustomTextField>
                                <Typography style={errorTextStyle}>{contactNumberError}</Typography>
                            </Grid>
                            <Grid item xs={12} sm={7} style={{padding: '0.5rem 0rem 0.5rem 0.5rem'}}>
                                <CustomTextField 
                                    regular={true} 
                                    placeHolder='Email *'
                                    value={email}
                                    setFunc = {updateEmail}
                                ></CustomTextField>
                                <Typography style={errorTextStyle}>{emailError}</Typography>
                            </Grid>
                            <Grid item xs={12} sm={5} style={{padding: '0.5rem 0rem 0.5rem 0.5rem'}}>
                                <CustomTextField regular={true} 
                                    placeHolder='Adhaar Number *'
                                    value={adhaar}
                                    setFunc={updateAdhaar}
                                ></CustomTextField>
                                <Typography style={errorTextStyle}>{adhaarError}</Typography>
                            </Grid>
                        </Grid>

                        <Box style={{display: 'flex', justifyContent: 'center', marginTop: '0.3rem'}}>
                            <Button style={{...buttonStyle}}
                                onClick={validateTab1}
                            >Next</Button>
                        </Box>
                        </>
                    }
                    { tab === 2 && 
                        <>
                            <Typography style={{color: headingBlue, fontSize: '1.1rem'}}>Other Details</Typography>
                            <Grid container spacing={1} style={{padding: '0.75rem 0rem 0.5rem 0rem'}}>
                                <Grid item xs={12} sm={6}>
                                    <CustomTextField placeHolder="Father's Name"
                                        value = {fatherName}
                                        setFunc = {updateFatherName}
                                    ></CustomTextField>
                                    <Typography style={errorTextStyle}>{fatherNameError}</Typography>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <CustomTextField placeHolder="Father's Occupation"
                                        value= {fatherContact}
                                        setFunc={updateFatherCN}
                                    ></CustomTextField>
                                    <Typography style={errorTextStyle}>{fatherContactError}</Typography>
                                </Grid>
                                <Grid item xs={12} sm={12}>
                                    <CustomTextField placeHolder="Address"
                                        regular = {true}
                                        isMultiLine={true}
                                        value={address}
                                        setFunc={updateAddress}
                                    ></CustomTextField>
                                    <Typography style={errorTextStyle}>{addressError}</Typography>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <CustomTextField 
                                        placeHolder = 'State'
                                        value={state} 
                                        setFunc={() => {}}
                                        disabled={true}
                                    ></CustomTextField>
                                    <Typography style={errorTextStyle}>{stateError}</Typography>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <CustomTextField 
                                        placeHolder = 'District'
                                        value={district} 
                                        setFunc={() => {}}
                                        disabled={true}
                                    ></CustomTextField>
                                    <Typography style={errorTextStyle}>{districtError}</Typography>
                                </Grid>
                            </Grid>

                            <Box style={{display: 'flex', justifyContent: 'center', marginTop: '0.3rem'}}>
                                <Button style={{...button2Style}}
                                    onClick={() => {setTab(() => tab - 1)}}
                                >Prev</Button>
                                <Button style={{...buttonStyle, marginLeft: '0.5rem'}}
                                    onClick={validateTab2}
                                >Next</Button>
                            </Box>
                        </>
                    }
                    { tab === 3 && 
                        <>
                            <Typography style={{color: headingBlue, fontSize: '1.1rem'}}>Education/ Profession</Typography>
                            <Grid container spacing={1} style={{padding: '0.75rem 0rem 0.5rem 0rem'}}>
                                <Grid item xs={12} sm={6}>
                                    <CustomDropDown placeHolder = 'Qualification'
                                        list={qualifications.map(q => ({ name: q.label }))}
                                        value={qualification}
                                        setFunc={updateQualification}
                                    ></CustomDropDown>
                                    {qualification !== 'Other' && <Typography style={errorTextStyle}>{qualificationError}</Typography>}
                                </Grid>
                                {qualification === 'Other' && (
                                    <Grid item xs={12} sm={6}>
                                        <CustomTextField 
                                            placeHolder="Enter Qualification"
                                            value={customQualification}
                                            setFunc={updateCustomQualification}
                                        ></CustomTextField>
                                        <Typography style={errorTextStyle}>{qualificationError}</Typography>
                                    </Grid>
                                )}
                                <Grid item xs={12} sm={(qualification === 'Other' && profession !== 'Other') ? 12 : 6}>
                                    <CustomDropDown
                                        placeHolder='Profession'
                                        list={professions.map(p => ({ name: p.label }))}
                                        value={profession}
                                        setFunc={updateProfession}
                                    ></CustomDropDown>
                                    {profession !== 'Other' && <Typography style={errorTextStyle}>{professionError}</Typography>}
                                </Grid>
                                {profession === 'Other' && (
                                    <Grid item xs={12} sm={6}>
                                        <CustomTextField 
                                            placeHolder="Enter Profession"
                                            value={customProfession}
                                            setFunc={updateCustomProfession}
                                        ></CustomTextField>
                                        <Typography style={errorTextStyle}>{professionError}</Typography>
                                    </Grid>
                                )}
                                <Grid item xs={12} sm={12}>
                                    <CustomTextField placeHolder=" Office Address"
                                        regular = {true}
                                        isMultiLine={true}
                                        value={offAdd}
                                        setFunc={updateOffAdd}
                                    ></CustomTextField>
                                </Grid>
                                <Grid item xs={4} sm={3}>
                                    <CustomDropDown regular={true} list={countryCodes}
                                        value={offTelCode}
                                        setFunc={updateOffTelCode}
                                    ></CustomDropDown>
                                </Grid>
                                <Grid item xs={8} sm={6}>
                                    <CustomTextField placeHolder = 'Office Contact'
                                        value={offContactNumber}
                                        setFunc={updateOffCN}
                                    ></CustomTextField>
                                </Grid>
                            </Grid>

                            <Box style={{display: 'flex', justifyContent: 'center', marginTop: '0.3rem'}}>
                                <Button style={{...button2Style}}
                                    onClick={() => {setTab(() => tab - 1)}}
                                >Prev</Button>
                                <Button style={{...buttonStyle, marginLeft: '0.5rem'}}
                                    onClick={validateTab3}
                                >Next</Button>
                            </Box>
                        </>
                    }
                    { tab === 4 && 
                        <>
                            <Typography style={{color: headingBlue, fontSize: '1.1rem'}}>About</Typography>
                            <Grid container spacing={1} style={{padding: '0.75rem 0rem 0.5rem 0rem'}}>
                                <Grid item xs={12} sm={12}>
                                    <CustomTextField 
                                        regular={true}
                                        isMultiLine= {true}
                                        rows={3}
                                        placeHolder=' Define Yourself and Your Goal in Life.'
                                        value={about}
                                        setFunc={updateAbout}
                                    >
                                    </CustomTextField>
                                </Grid>
                                <Grid item xs={12} sm={12}>
                                    <CustomTextField 
                                        regular={true}
                                        isMultiLine= {true}
                                        rows={2}
                                        placeHolder=' Hobbies.'
                                        value={hobbies}
                                        setFunc={updateHobbies}
                                    >
                                    </CustomTextField>
                                </Grid>
                                <Grid item xs={12} sm={12}>
                                    <CustomTextField placeHolder=" Extra Curricular Activities"
                                        regular = {true}
                                        isMultiLine={true}
                                        rows={2}
                                        value={extraCurricular}
                                        setFunc={updateExtraCurricular}
                                    ></CustomTextField>
                                </Grid>
                                <Grid item xs={12} sm={12}>
                                    <CustomTextField placeHolder=" Why do you want to join our NGO?"
                                        regular = {true}
                                        isMultiLine={true}
                                        rows={3}
                                        value={reasonToJoin}
                                        setFunc={updateReasonToJoin}
                                    ></CustomTextField>
                                </Grid>
                            </Grid>

                            <Box style={{display: 'flex', justifyContent: 'center', marginTop: '0.3rem'}}>
                                <Button style={{...button2Style}}
                                    onClick={() => {setTab(() => tab - 1)}}
                                >Prev</Button>
                                <Button style={{...buttonStyle, marginLeft: '0.5rem'}}
                                    onClick={() => setTab(() => tab + 1)}
                                >Next</Button>
                            </Box>
                        </>
                    }
                    { tab === 5 && 
                        <>
                            <Typography style={{color: headingBlue, fontSize: '1.1rem'}}>Photo/ Signature/ Aadhar</Typography>
                            <Grid container spacing={2} style={{padding: '0.75rem 0rem 0.5rem 0rem'}}>
                                <Grid item xs={12} sm={12}>
                                    <input type="file" accept=".jpeg, .png, image/jpeg, image/png" style={{ display: 'none' }} ref={photoRef} onChange={(e) => handleFileUpload(e, setPhoto, setPhotoError, 500)} />
                                    <Box onClick={() => photoRef.current?.click()} style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', width: '100%', height: '7rem', border: '1px dashed #C3C3C3', borderRadius: '0.5rem', cursor: 'pointer', overflow: 'hidden'}}>
                                        {photo ? (
                                            <img src={URL.createObjectURL(photo)} alt="Photograph" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
                                        ) : (
                                            <>
                                                <CloudUpload style={{color: headingBlue}}></CloudUpload>
                                                <Typography>Upload Photograph</Typography>
                                                <Typography style={{color: 'red', fontSize: '0.75rem'}}>Max Size 500kb</Typography>
                                            </>
                                        )}
                                    </Box>
                                    {photoError && <Typography style={errorTextStyle}>{photoError}</Typography>}
                                </Grid>
                                <Grid item xs={12} sm={12}>
                                    <input type="file" accept=".jpeg, .png, image/jpeg, image/png" style={{ display: 'none' }} ref={signatureRef} onChange={(e) => handleFileUpload(e, setSignature, setSignatureError)} />
                                    <Box onClick={() => signatureRef.current?.click()} style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', width: '100%', height: '7rem', border: '1px dashed #C3C3C3', borderRadius: '0.5rem', cursor: 'pointer', overflow: 'hidden'}}>
                                        {signature ? (
                                            <img src={URL.createObjectURL(signature)} alt="Signature" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
                                        ) : (
                                            <>
                                                <CloudUpload style={{color: headingBlue}}></CloudUpload>
                                                <Typography>Upload Signature</Typography>
                                                <Typography style={{color: 'red', fontSize: '0.75rem'}}>Max Size 200kb</Typography>
                                            </>
                                        )}
                                    </Box>
                                    {signatureError && <Typography style={errorTextStyle}>{signatureError}</Typography>}
                                </Grid>
                                <Grid item xs={12} sm={12}>
                                    <input type="file" accept=".jpeg, .png, image/jpeg, image/png" style={{ display: 'none' }} ref={aadharRef} onChange={(e) => handleFileUpload(e, setAadharFile, setAadharFileError)} />
                                    <Box onClick={() => aadharRef.current?.click()} style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', width: '100%', height: '7rem', border: '1px dashed #C3C3C3', borderRadius: '0.5rem', cursor: 'pointer', overflow: 'hidden'}}>
                                        {aadharFile ? (
                                            <img src={URL.createObjectURL(aadharFile)} alt="Aadhar Card" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
                                        ) : (
                                            <>
                                                <CloudUpload style={{color: headingBlue}}></CloudUpload>
                                                <Typography>Upload Aadhar Card</Typography>
                                                <Typography style={{color: 'red', fontSize: '0.75rem'}}>Max Size 200kb</Typography>
                                            </>
                                        )}
                                    </Box>
                                    {aadharFileError && <Typography style={errorTextStyle}>{aadharFileError}</Typography>}
                                </Grid>
                            </Grid>
                            <Box style={{display: 'flex', justifyContent: 'center', marginTop: '0.3rem'}}>
                                <Button style={{...button2Style}}
                                    onClick={() => {setTab(() => tab - 1)}}
                                >Prev</Button>
                                <Button style={{...buttonStyle, marginLeft: '0.5rem'}}
                                    onClick={() => validateTab5()}
                                >Next</Button>
                            </Box>
                        </>
                    }
                    {tab === 6 && !isRegistered &&
                    <>
                        <Box style={{ marginTop: '0.5rem' }}>
                            <Typography>
                                <Checkbox 
                                    checked={isAgreed}
                                    onChange={(e) => setIsAgreed(e.target.checked)}
                                    sx={{ float: 'left', padding: '0rem 0.5rem 0rem 0rem', '&.Mui-checked': { color: headingBlue } }}
                                />
                                I {name} , declare that all the information furnished in this form is 
                                true to the best of my knowledge and belief. I make a pledge to work for compassion activities in the interest 
                                of the organisation and not do anything detrimental to the cause or the reputation of the organisation. By 
                                signing this document, I agree to be part of this organisation and work for it and ready to obey and follow 
                                orders and task assigned by my State Head and/or Local Authority under the leadership of the President 
                                Allama Syed Abdullah Tariq.
                            </Typography>
                        </Box>
                        <Box style={{display: 'flex', justifyContent: 'center', marginTop: '0.8rem'}}>
                                 <Button style={{...button2Style}}
                                    onClick={() => {setTab(() => tab - 1)}}
                                >Prev</Button>
                                <Button style={{...buttonStyle, marginLeft: '0.5rem', opacity: !isAgreed ? 0.5 : 1}}
                                    disabled={!isAgreed}
                                    onClick={handleRegister}
                                >Submit</Button>
                        </Box>  
                    </>  
                    }
                    {isRegistered &&
                        <Box style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '7rem'}}>
                            <Typography style={{textAlign: 'center', color: headingBlue, fontSize: '1.2rem', fontWeight: 600}}>
                                Alhamdulillah, Your Registration is Successful.
                            </Typography>
                        </Box>
                    }
                    {apiError &&
                        <Box style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '0.75rem 0.5rem 0.5rem 0.5rem'}}>
                            <Typography style={{...errorTextStyle, textAlign: 'center', fontSize: '1rem'}}>{apiError}</Typography>
                        </Box>
                    }
                </Paper>

            </Box>

        </Box>
    </>
  )
}

export default RegistrationForm
